import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal'
import '../../App.css'
import firebase from '../../Config/Firebase'
import FileUploader from "react-firebase-file-uploader";
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
import imageCompression from 'browser-image-compression';
import generator from 'generate-password'




const styles = theme => ({
    root: {
        flexGrow: 1,
    },
})







class App extends Component {


    constructor(props) {
        super(props)
        this.state = {
            show: false,
            img: "",
            isUploading: false,
            progress: 0,
            imgurl: "",
            text: props.text,
            user: {},
            descenter: false
        }
    }

    componentWillReceiveProps(props) {
        this.setState({ show: props.open })
        this.setState({ text: props.text })

    }



    dunc = (e) => {
        this.setState({ text: e.target.value })
    }


    editclue = () => {
        if (this.state.text !== "") {
            if (this.state.imgurl !== "") {
                firebase.database().ref(`clue/${this.props.user.id}/${this.props.clue.clueId}`).update({
                    clueImage: this.state.imgurl,
                    clueText: this.state.text
                });
            }
            else {
                firebase.database().ref(`clue/${this.props.user.id}/${this.props.clue.clueId}`).update({
                    clueText: this.state.text
                });
            }
            this.props.reload()
        }
        else {
            this.setState({ descenter: true })
            setTimeout(() => {
                this.setState({ descenter: false })
            }, 3000);
        }


    }


    handleImageUpload(event) {
        let self = this;
        var userid = this.props.user.groupId;
        //console.log("this user.id",userid)
        var password = generator.generate({
            length: 15,
            numbers: true
        });
        this.setState({ isUploading: true })
        var imageFile = event.target.files[0];
        //console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
        //console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

        var options = {
            maxSizeMB: 0.3,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        }
        imageCompression(imageFile, options)
            .then(function (compressedFile) {
                //console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
                //console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
                var storageRef = firebase.storage().ref(`clues/${userid}`)
                var task = storageRef.child(password).put(compressedFile);
                task.on('state_changed', (snapshot) => {
                    var progress = Math.round(100 * snapshot.bytesTransferred / snapshot.totalBytes);
                    self.setprogress(progress)
                }, function (error) {
                    //console.log(error,"imguploaderror")
                }, function () {
                    self.handleUploadSuccess(password)
                })
                // write your own logic
            })
            .catch((error) => {
                //console.log(error.message);
            });

    }

    setprogress = (p) => {
        this.setState({ progress: p })
    }





    handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
    handleProgress = progress => this.setState({ progress });
    handleUploadError = error => {
        this.setState({ isUploading: false });
        console.error(error);
    };
    handleUploadSuccess = filename => {
        this.setState({ img: filename, progress: 100, isUploading: false });
        firebase
            .storage()
            .ref(`clues/${this.props.userid}`)
            .child(filename)
            .getDownloadURL()
            .then(url => this.setState({ imgurl: url }));
    };



    render() {
        const { classes } = this.props;
        return (
            <Modal

                show={this.state.show}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop={"static"}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Clue
           </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: "40vh" }}>

                    <div className="btn btn-primary btn-xl" style={{ width: "100%" }}>
                        <input type="file" accept="image/*" onChange={(e) => { this.handleImageUpload(e) }} />
                    </div>
                    <br /><br />
                    {this.state.isUploading && <LinearProgress variant="determinate" value={this.state.progress} />}
                    <br />
                    {/* <input class="form-control" type="text" value={this.props.title}/> */}
                    <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" defaultValue={this.props.text} onChange={(e) => { this.dunc(e) }}></textarea><br />
                    {this.state.isUploading === false && <button className="btn btn-primary" style={{ marginLeft: "45%" }} type="button" onClick={this.editclue}>Update</button>}
                    {this.state.descenter && <div style={{ color: "#000080", fontFamily: "Roboto", textAlign: "center" }}><p>Please Enter Some Description</p></div>}

                </Modal.Body>
                <Modal.Footer>

                    <button onClick={() => { this.setState({ show: false }) }} className="btn btn-danger">Close</button>
                </Modal.Footer>
            </Modal>)
    }

}
export default withStyles(styles)(App);